import { useOutletContext } from 'react-router-dom'
import { TransactionLog } from '@/pages/program_purse_settings/_components/transaction-log.tsx'
import { ProgramPurseResource } from '@/queries/program_purses/schemas.ts'

interface OutletContext {
  purse: ProgramPurseResource
}

export const TransactionsTabLoader = () => {
  const { purse } = useOutletContext<OutletContext>()

  return <TransactionLog purse={purse} />
}
